export const visit = (vm, at) => {
at({ "en": { "hubspotRtePlugins": { "branding": { "poweredByHubSpot": "Powered by <a href=\"{{ link }}\" target=\"_blank\" rel=\"noopener\">HubSpot</a>." } } } });
};